import styled from "@emotion/styled";
import { MIN_WIDTH_DESKTOP, useDeviceType, useIsMobile, useIsTablet } from "hooks/useDeviceType";
import { useMemo } from "react";
import { ThemeProp } from "styles/theme";
import { heightAdjust } from "../../../components/NavbarV2/elements/NavbarContainer";

export const ActivityContainer = styled.div<ThemeProp>(({ theme }) => {
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  const deviceType = useDeviceType();
  const margin = useMemo(() => {
    console.log(`isMobile`, isMobile);
    console.log(`isTablet`, isTablet);
    console.log(`deviceType`, deviceType);
    if (isMobile) {
      return "6px 0";
    } else if (isTablet) {
      return "6px auto";
    }
    return "30px auto";
  }, [deviceType, isMobile, isTablet]);

  return {
    background: theme.surface.main.primary.default,
    margin,
    padding: isMobile ? "10px 0 0 8px" : "32px 30px",
    borderRadius: isMobile ? "0" : "25px",
    display: "flex",
    flexDirection: "column",
    height: `calc(100dvh - ${heightAdjust(deviceType) + 62}px);`, //62px is the height of the margin and padding of Activity
    maxHeight: "99dvh",
    minWidth: "95%",
    maxWidth: MIN_WIDTH_DESKTOP,
    fontFamily: theme.fontFamilies.Primary,
    boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.50), 0px 1px 15px 0px rgba(0, 0, 0, 0.25)",
    zIndex: "1003",
  };
});
